<template>
  <ButtonSnsSmall class="btn-sns--messenger" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-messenger-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--messenger {
  @include bg-settings(
    '../../../../../../images/buttons/messenger-with-background.svg',
    $messenger,
    100%,
    100%
  );
}
</style>
